import { isoToDateString, isoToDateTimeString, monthEnding } from "utils/date";
  
export default [

  { field: 'license', width: 150, headerAlign: 'center', headerName: 'Лицензия' },

  { field: 'duration', flex: 1, headerAlign: 'center', headerName: 'Длительность', align: 'center', 
    valueGetter: (value) => `${value} ${monthEnding(value)}` },
  
  { field: 'usedAt', headerAlign: 'center', headerName: 'Загружена', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateTimeString(value) },     

  { field: 'activatedAt', headerAlign: 'center', headerName: 'Активирована', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateTimeString(value) },  

  { field: 'licenseEndAt', headerAlign: 'center', headerName: 'Действует до', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateString(value) },

  { field: 'name', headerAlign: 'center', headerName: 'Касса', width: 160, align: 'right',
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}` }

];